import { useState, useEffect } from 'react';
import Modal from '../../../../commons/Modal/Modal';
import { useNavigate } from 'react-router-dom';
import { LaunchingRegisterModalProps } from './LaunchingRegisterModal.types';
import Button from '../../../../designSystem/Button/Button';

export const LaunchingRegisterModal = ({
  setOpen,
  isOpen,
  isLoading,
  isSuccess,
}: LaunchingRegisterModalProps) => {
  const navigate = useNavigate();

  const [countdown, setCountdown] = useState(10);

  useEffect(() => {
    let timer: any = null;
    if (isOpen && !isLoading && isSuccess) {
      timer = setInterval(() => {
        setCountdown((value) => value - 1);
      }, 1000);
      return () => clearInterval(timer);
    } else {
      clearInterval(timer);
      setCountdown(10);
    }
  }, [isOpen, isLoading, isSuccess]);

  useEffect(() => {
    if (countdown === 0) {
      navigate('/');
    }
  }, [countdown]);

  return (
    <Modal setOpen={setOpen} isOpen={isOpen}>
      {isLoading ? (
        <div className="custom-loader"></div>
      ) : (
        <>
          <h2>Votre inscription a bien été prise en compte</h2>
          <p>Vous allez être redirigé vers la page d'accueil dans {countdown} secondes</p>
          <Button onClick={() => navigate('/')} style={{ alignSelf: 'center', marginTop: 12 }}>
            Retour à l'accueil
          </Button>
        </>
      )}
    </Modal>
  );
};
